import { AxiosInstance } from "axios";
import { BaseApiModule } from "./base.module";
import { unstrapiMany, unstrapiOne } from "../../helpers/strapi";
import { AICoachType } from "../../types/appointment-types";


export class AICoachesApiModule extends BaseApiModule {
  constructor(client: AxiosInstance) {
    super(client, "api");
  }

  create(data: any) {
    return this.client
      .post(`/api/ai-coaches`, { data })
      .then((res) => res.data);
  }

  fetchAICoaches({ populate, filters }: { populate?: string[], filters?: any } = {}) {
    return this.client
      .get(`api/ai-coaches`, {
        params: {
          populate: ["user_setting.user"],
          filters
        }
      })
      .then((res) => {
        const resp = unstrapiMany<AICoachType>(res.data, "aiCoach")
        //console.debug ('Fetch Accounts - ' + JSON.stringify(resp))
        return resp;
      }
      );
  }


}
